/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Sketchfab3dImageryComponent } from './sketchfab-3d-imagery.component';

@NgModule({
	declarations: [Sketchfab3dImageryComponent],
	imports: [
		CommonModule
	],
	exports: [Sketchfab3dImageryComponent]
})
export class Sketchfab3dImageryModule {}
